import {MenuStrategy} from "../MenuStrategy";

export class HomeMenuStrategy extends MenuStrategy {
   constructor() {
    super('Home', '', 'app-home');
  }
}
